import React from "react";
import styles from "./users.module.scss";
import { AuthenticationService } from "../../authenticationService";
import { Api } from "../../Api";
import { User } from "../../models";
import Loader from "../../components/loader/component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Logger } from "../../Logger";

class Users extends React.Component<IUsersProps, IUsersState> {
    private _authService: AuthenticationService;

    constructor(props: IUsersProps) {
     super(props);

        this._authService = props.authenticationService;

        this.state = {
            loading: true,
       showAdd: false,
            users: [],
   email: "",
          isAdmin: false,
      isConsultant: false,
            editingUserId: null
     };

 this.onAddUser = this.onAddUser.bind(this);
     this.onAddSubmitUser = this.onAddSubmitUser.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
     this.onChangeAdmin = this.onChangeAdmin.bind(this);
        this.onChangeConsultant = this.onChangeConsultant.bind(this);
    }

    componentDidMount() {
   this.loadUsers();
    }

    loadUsers() {
        Api.getAllUsers().then((res: User[]) => {
   this.setState({
 loading: false,
     users: res
       });
        });
    }

    onAddUser() {
        this.setState({ showAdd: true, editingUserId: null });
    }

    onAddSubmitUser() {
        if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email)) {
  this.setState({ loading: true });

    var user = new User();
            user.email = this.state.email;
      user.isAdmin = this.state.isAdmin;
     user.isConsultant = this.state.isConsultant;

      Api.addUser(user).then(() => {
          Logger.LogSuccess("Gebruiker toegevoegd");
      this.setState({ showAdd: false, email: "", isAdmin: false, isConsultant: false });
       this.loadUsers();
       }).catch(() => {
     this.setState({ loading: false });
      });
        } else {
            Logger.LogErrorMessage("Ongeldig email adres");
        }
    }

    onChangeEmail(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ email: event.target.value });
    }

    onChangeAdmin(event: React.ChangeEvent<HTMLInputElement>) {
     this.setState({ isAdmin: event.target.checked });
    }

    onChangeConsultant(event: React.ChangeEvent<HTMLInputElement>) {
this.setState({ isConsultant: event.target.checked });
    }

    onBlockUser(user: User) {
     if (!window.confirm(`Weet je zeker dat je ${user.email} wilt blokkeren?`))
         return;
        this.setState({ loading: true });
        Api.blockUser(user.id).then(() => {
  Logger.LogSuccess("Gebruiker geblokkeerd");
      this.loadUsers();
    }).catch(() => {
      Logger.LogErrorMessage("Fout bij blokkeren");
            this.setState({ loading: false });
      });
    }

    onUnblockUser(user: User) {
        this.setState({ loading: true });
        Api.unblockUser(user.id).then(() => {
            Logger.LogSuccess("Gebruiker gedeblokkeerd");
            this.loadUsers();
      }).catch(() => {
Logger.LogErrorMessage("Fout bij deblokkeren");
            this.setState({ loading: false });
      });
    }

 onResendActivationEmail(user: User) {
        if (!window.confirm(`Activatie e-mail opnieuw versturen naar ${user.email}?`))
            return;
  this.setState({ loading: true });
      Api.resendActivationEmail(user.id).then(() => {
   Logger.LogSuccess("Activatie e-mail verstuurd");
 this.loadUsers();
  }).catch(() => {
   Logger.LogErrorMessage("Fout bij versturen van e-mail");
   this.setState({ loading: false });
        });
    }

  onResetPassword(user: User) {
        if (!window.confirm(`Wachtwoord resetten voor ${user.email}? De gebruiker ontvangt een nieuwe activatie e-mail.`))
   return;
  this.setState({ loading: true });
  Api.resetPassword(user.id).then(() => {
          Logger.LogSuccess("Wachtwoord gereset, activatie e-mail verstuurd");
        this.loadUsers();
        }).catch(() => {
     Logger.LogErrorMessage("Fout bij resetten van wachtwoord");
            this.setState({ loading: false });
        });
    }

    onEditUser(user: User) {
        this.setState({
 editingUserId: user.id,
   showAdd: false
      });
    }

    onCancelEdit() {
        this.setState({ editingUserId: null });
        this.loadUsers();
    }

    onToggleEditField(userId: string, field: "isAdmin" | "isConsultant") {
        const users = this.state.users.map(u => {
 if (u.id === userId) {
                return { ...u, [field]: !u[field] };
        }
     return u;
        });
        this.setState({ users });
    }

    onSaveUser(user: User) {
        this.setState({ loading: true });
    Api.updateUser(user).then(() => {
 Logger.LogSuccess("Gebruiker bijgewerkt");
            this.setState({ editingUserId: null });
     this.loadUsers();
    }).catch(() => {
Logger.LogErrorMessage("Fout bij bijwerken");
 this.setState({ loading: false });
  });
    }

    getStatusLabel(status: number): string {
    switch (status) {
      case 1: return "Wacht op activatie";
   case 2: return "Actief";
      default: return "Onbekend";
        }
    }

    render() {
        const self = this;
        return (
            <div className={styles.container}>
       <h1>Overzicht gebruikers</h1>
       {this.state.loading && <Loader />}
     {!this.state.loading &&
      <table className={styles.customTable + " table"}>
           <thead>
       <tr>
       <th scope="col">Email</th>
           <th scope="col">Beheerder</th>
   <th scope="col">Consultant</th>
       <th scope="col">Geblokkeerd</th>
            <th scope="col">Status</th>
             <th scope="col">Acties</th>
        </tr>
           </thead>
         <tbody>
     {this.state.users.map(function (item: User) {
 const isEditing = self.state.editingUserId === item.id;
          return <tr key={item.id} className={item.isBlocked ? styles.blockedRow : ""}>
      <td>{item.email}</td>
     <td>
     {isEditing
            ? <input type="checkbox" checked={item.isAdmin} onChange={() => self.onToggleEditField(item.id, "isAdmin")} />
        : (item.isAdmin ? "Ja" : "Neen")}
       </td>
     <td>
         {isEditing
  ? <input type="checkbox" checked={item.isConsultant} onChange={() => self.onToggleEditField(item.id, "isConsultant")} />
      : (item.isConsultant ? "Ja" : "Neen")}
         </td>
         <td>{item.isBlocked ? "Ja" : "Neen"}</td>
   <td>{self.getStatusLabel(item.status)}</td>
             <td className={styles.actions}>
    {isEditing ? (
       <>
      <button type="button" className="btn btn-sm btn-success" title="Opslaan" onClick={() => self.onSaveUser(item)}>
   <FontAwesomeIcon icon="save" />
        </button>
       <button type="button" className="btn btn-sm btn-secondary" title="Annuleren" onClick={() => self.onCancelEdit()}>
           <FontAwesomeIcon icon="times" />
     </button>
      </>
      ) : (
             <>
            <button type="button" className="btn btn-sm btn-outline-primary" title="Rechten aanpassen" onClick={() => self.onEditUser(item)}>
           <FontAwesomeIcon icon="edit" />
            </button>
       {!item.isBlocked
          ? <button type="button" className="btn btn-sm btn-outline-danger" title="Blokkeren" onClick={() => self.onBlockUser(item)}>
          <FontAwesomeIcon icon="ban" />
           </button>
       : <button type="button" className="btn btn-sm btn-outline-success" title="Deblokkeren" onClick={() => self.onUnblockUser(item)}>
         <FontAwesomeIcon icon="unlock" />
        </button>
   }
        {item.status === 1 &&
     <button type="button" className="btn btn-sm btn-outline-info" title="Activatie e-mail opnieuw versturen" onClick={() => self.onResendActivationEmail(item)}>
  <FontAwesomeIcon icon="envelope" />
    </button>
  }
          {item.status === 2 &&
            <button type="button" className="btn btn-sm btn-outline-warning" title="Wachtwoord resetten" onClick={() => self.onResetPassword(item)}>
            <FontAwesomeIcon icon="key" />
      </button>
                   }
         </>
       )}
    </td>
              </tr>
             })}
        </tbody>
              </table>
          }

     {!this.state.loading && !this.state.showAdd && <div>
               <button type="button" className="btn btn-primary" onClick={this.onAddUser}><FontAwesomeIcon icon="plus-circle" /> Toevoegen</button>
      </div>}

    {!this.state.loading && this.state.showAdd && <div>
     <h1>Nieuwe gebruiker</h1>

      <div className={styles.newUser}>
     <input type="text" className="form-control" placeholder="Email" value={this.state.email} onChange={this.onChangeEmail} />
              <label><input type="checkbox" name="isAdmin" checked={this.state.isAdmin} onChange={this.onChangeAdmin} /> Beheerder</label><br />
    <label><input type="checkbox" name="isConsultant" checked={this.state.isConsultant} onChange={this.onChangeConsultant} /> Firesafeplus consultant</label><br />
                 <button type="button" className="btn btn-success" onClick={this.onAddSubmitUser}><FontAwesomeIcon icon="save" /> Opslaan</button>
      </div>
 </div>}
     </div>
 );
    }
}

export default Users;

export interface IUsersProps {
    authenticationService: AuthenticationService;
}

export interface IUsersState {
  loading: boolean;
    showAdd: boolean;
    users: User[];

    email: string;
    isAdmin: boolean;
    isConsultant: boolean;
    editingUserId: string | null;
}